import { matchPath } from 'react-router'

const FLAG_KEY = 'tanstack_router_shell'

/**
 * Pre-mount toggle for the TanStack Router coexistence shell.
 *
 * Read synchronously before render: account/partner feature toggles load only after
 * the app boots, inside the router this decides. URL param wins (one-off QA override),
 * then localStorage (sticky per browser). Without either override, match the current path
 * against the route catalog injected by apps/ipp. Only a direct load of a route named in
 * `nativeShellRouteNames` (each domain's own opt-in list, collected by the app) enables the
 * shell; other initial routes stay legacy.
 */
export function isTanstackShellEnabled(
  routeCatalog?: Readonly<Record<string, string>>,
  nativeShellRouteNames: readonly string[] = []
): boolean {
  if (typeof window === 'undefined') return false

  const param = new URLSearchParams(window.location.search).get(FLAG_KEY)
  if (param === '1' || param === 'true') return true
  if (param === '0' || param === 'false') return false

  try {
    const storedFlag = window.localStorage.getItem(FLAG_KEY)
    if (storedFlag === '1') return true
    if (storedFlag === '0' || storedFlag === 'false') return false
  } catch {
    // Storage can be unavailable; route-catalog activation must still work.
  }

  return nativeShellRouteNames.some(name => {
    const pattern = routeCatalog?.[name]
    return Boolean(pattern && matchPath(window.location.pathname, { path: pattern, exact: true }))
  })
}
